'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = function size(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.menu.item,
      minHeight = _theme$reactackle$com.minHeight,
      paddingY = _theme$reactackle$com.paddingY,
      paddingX = _theme$reactackle$com.paddingX;


  return (0, _styledComponents.css)(['min-height:', ';padding:', ' ', ';'], (0, _reactackleCore.getValueString)(minHeight), (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX));
};

var colorScheme = function colorScheme(_ref2) {
  var colorScheme = _ref2.colorScheme,
      active = _ref2.active,
      themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.menu.item.colorScheme[colorScheme];

  var defaultBgColor = path.backgroundColor,
      backgroundColorHover = path.backgroundColorHover,
      backgroundColorFocus = path.backgroundColorFocus,
      backgroundColorActive = path.backgroundColorActive,
      defaultColor = path.color,
      colorHover = path.colorHover,
      colorFocus = path.colorFocus,
      colorActive = path.colorActive;


  return active ? (0, _styledComponents.css)(['&,&:hover,&:focus{background-color:', ';color:', ';}'], backgroundColorActive || defaultBgColor, colorActive || defaultColor) : (0, _styledComponents.css)(['background-color:', ';color:', ';&:hover{background-color:', ';color:', ';}&:focus{background-color:', ';color:', ';}'], defaultBgColor, defaultColor, backgroundColorHover || defaultBgColor, colorHover || defaultColor, backgroundColorFocus || defaultBgColor, colorFocus || defaultColor);
};

var AnchorStyled = exports.AnchorStyled = _styledComponents2.default.a.withConfig({
  displayName: 'AnchorStyled'
})(['width:100%;display:flex;flex-grow:1;padding:0;align-items:center;text-decoration:none;position:relative;cursor:pointer;user-select:none;', ' ', ' ', ' &:hover,&:focus{outline:none;}'], size, colorScheme, (0, _reactackleCore.transition)('background-color'));

AnchorStyled.displayName = 'AnchorStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-menu/dist/MenuItem/styles/AnchorStyled.js
// module id = 739
// module chunks = 0